import { FaDatabase, FaServer, FaUserAlt, FaUserShield, FaIndustry } from "react-icons/fa";
import { GiWorld } from "react-icons/gi";
import { LuTicketCheck } from "react-icons/lu";
import { MdGroups } from "react-icons/md";
import { RiLockPasswordLine } from "react-icons/ri";
import images from "./images";
import { TbCertificate } from "react-icons/tb";
import { RiCloudLine } from "react-icons/ri";
import {
  SiFortinet,
  SiHuawei,
  SiJunipernetworks,
  SiMikrotik,
  SiNokia,
  SiNvidia
} from "react-icons/si";
import GoogleCloudLogo from "../images/google-cloud_logo.png";
import AzureLogo from "../images/ResourceIcons/azure.svg";
import AWSLogo from "../images/AWS.svg";
export const resourceListCards = (t) => [
  {
    id: 1,
    title: "MySQL",
    description: t("resources.database"),
    imageURL: images.mysql,
    resource_type: "database",
    link: "/dashboard/resources/apps/add-apps/mysql",
  },
  {
    id: 2,
    title: "PostgreSQL",
    description: t("resources.database"),
    imageURL: images.pssql,
    resource_type: "database",
    link: "/dashboard/resources/apps/add-apps/postgreSQL",
    keywords: ["pgsql"],
  },
  {
    id: 3,
    title: "MSSQL",
    description: t("resources.database"),
    imageURL: images.mssql,
    resource_type: "database",
    link: "/dashboard/resources/apps/add-apps/mssql",
  },
  {
    id: 4,
    title: "OracleDB",
    description: t("resources.database"),
    imageURL: images.oracle,
    resource_type: "database",
    link: "/dashboard/resources/apps/add-apps/oracledb",
  },
  {
    id: 5,
    title: "SaphanaDB",
    description: t("resources.database"),
    imageURL: images.sap,
    resource_type: "database",
    link: "/dashboard/resources/apps/add-apps/sapHanadb",
  },
  {
    id: 6,
    title: "Linux",
    description: t("resources.server"),
    imageURL: images.linux,
    resource_type: "server",
    link: "/dashboard/resources/assets/add-assets/ssh",
    keywords: ["ssh"],
  },
  {
    id: 7,
    title: "Window",
    description: t("resources.server"),
    imageURL: images.windows,
    resource_type: "server",
    link: "/dashboard/resources/assets/add-assets/rdp",
    keywords: ["rdp"],
  },

  {
    id: 8,
    title: "Kubernetes",
    description: t("resources.server"),
    imageURL: images.kubernetes,
    resource_type: "server",
    link: "/dashboard/resources/apps/add-apps/kubernetes",
    keywords: ["k8s"],
  },
  {
    id: 9,
    title: "VNC",
    description: t("resources.server"),
    imageURL: images.vnc,
    resource_type: "server",
    link: "/dashboard/resources/assets/add-assets/vnc",
  },
  {
    id: 10,
    title: "Go Daddy",
    description: t("resources.webApplication"),
    imageURL: images.GoDaddy,
    resource_type: "web_application",
    link: "/dashboard/resources/web-apps/add/go-daddy",
  },
  {
    id: 11,
    title: "AWS",
    description: t("resources.webApplication"),
    imageURL: images.AWS,
    resource_type: "web_application",
    link: "/dashboard/resources/web-apps/add/aws",
  },
  {
    id: 12,
    title: "Microsoft Office",
    description: t("resources.webApplication"),
    imageURL: images.microsoftOffice,
    resource_type: "web_application",
    link: "/dashboard/resources/web-apps/add/microsoft-office",
  },
  {
    id: 13,
    title: "JIRA",
    description: t("resources.webApplication"),
    imageURL: images.JIRA,
    resource_type: "web_application",
    link: "/dashboard/resources/web-apps/add/jira",
  },
  {
    id: 14,
    title: "Azure",
    description: t("resources.webApplication"),
    imageURL: images.AzureWebapp,
    resource_type: "web_application",
    link: "/dashboard/resources/web-apps/add/azure",
  },
  {
    id: 15,
    title: "Slack",
    description: t("resources.webApplication"),
    imageURL: images.slack,
    resource_type: "web_application",
    link: "/dashboard/resources/web-apps/add/slack",
  },
  {
    id: 16,
    title: "Custom",
    description: t("resources.webApplication"),
    imageURL: images.customWebApp,
    resource_type: "web_application",
    link: "/dashboard/resources/web-apps/add",
  },
  {
    id: 17,
    title: "Command Prompt",
    description: t("resources.desktopApplication"),
    imageURL: images.cmd,
    resource_type: "desktop_application",
    link: "/dashboard/resources/web-apps/add/desktop-application/cmd",
  },
  {
    id: 18,
    title: "Notepad",
    description: t("resources.desktopApplication"),
    imageURL: images.notepad,
    resource_type: "desktop_application",
    link: "/dashboard/resources/web-apps/add/desktop-application/notepad",
  },
  {
    id: 19,
    title: "Remote Desktop",
    description: t("resources.desktopApplication"),
    imageURL: images.rdp,
    resource_type: "desktop_application",
    link: "/dashboard/resources/web-apps/add/desktop-application/rdp",
      },
  {
    id: 20,
    title: "Media Player",
    description: t("resources.desktopApplication"),
    imageURL: images.windows_media_player,
    resource_type: "desktop_application",
    link: "/dashboard/resources/web-apps/add/desktop-application/media-player",
  },
  {
    id: 21,
    title: "Paint",
    description: t("resources.desktopApplication"),
    imageURL: images.paint,
    resource_type: "desktop_application",
    link: "/dashboard/resources/web-apps/add/desktop-application/paint",
  },
  {
    id: 22,
    title: "Powershell",
    description: t("resources.desktopApplication"),
    imageURL: images.powershell,
    resource_type: "desktop_application",
    link: "/dashboard/resources/web-apps/add/desktop-application/powershell",
  },
  {
    id: 23,
    title: "Registry Editor",
    description: t("resources.desktopApplication"),
    imageURL: images.registry_editor,
    resource_type: "desktop_application",
    link: "/dashboard/resources/web-apps/add/desktop-application/registry-editor",
  },
  {
    id: 24,
    title: "File Explorer",
    description: t("resources.desktopApplication"),
    imageURL: images.file_explorer,
    resource_type: "desktop_application",
    link: "/dashboard/resources/web-apps/add/desktop-application/file-explorer",
  },
  {
    id: 25,
    title: "Control Panel",
    description: t("resources.desktopApplication"),
    imageURL: images.control_panel,
    resource_type: "desktop_application",
    link: "/dashboard/resources/web-apps/add/desktop-application/control-panel",
  },
  {
    id: 26,
    title: "Microsoft Edge",
    description: t("resources.desktopApplication"),
    imageURL: images.microsoft_edge,
    resource_type: "desktop_application",
    link: "/dashboard/resources/web-apps/add/desktop-application/microsoft-edge",
  },
  {
    id: 27,
    title: "SFTP",
    description: t("resources.server"),
    imageURL: images.sftp,
    resource_type: "server",
    link: "/dashboard/resources/assets/add-assets/sftp",
  },
  {
    id: 28,
    title: "SMB",
    description: t("resources.server"),
    imageURL: images.smb,
    resource_type: "server",
    link: "/dashboard/resources/assets/add-assets/smb",
  },
  {
    id: 29,
    title: "Custom",
    description: t("resources.desktopApplication"),
    imageURL: images.customWebApp,
    resource_type: "desktop_application",
    link: "/dashboard/resources/web-apps/add/desktop-application",
  },
  {
    id: 30,
    title: t("resources.applicationCredentials"),
    description: t("resources.applicationCredentials"),
    imageURL: images.customWebApp,
    resource_type: "application_credentials",
    link: "/dashboard/resources/assets/add-assets/application-credentials/api",
  },
  // Networking Devices - Switches
{
  id: 31,
  title: "Juniper Networks",
  description: t("resources.switch"),
  logoComponent: <SiJunipernetworks />,
  color:"#000000",
  resource_type: "switch",
  isNetworkingDevice: true,
  ssh_support: true,
  web_support: true,
},
{
  id: 32,
  title: "MikroTik",
  description: t("resources.switch"),
  logoComponent: <SiMikrotik />,
  color: "#323232",
  resource_type: "switch",
  isNetworkingDevice: true,
  ssh_support: true,
  web_support: true,
},
{
  id: 33,
  title: "Nokia Devices",
  description: t("resources.switch"),
  logoComponent: <SiNokia />,
  color: "#005AFF",
  resource_type: "switch",
  isNetworkingDevice: true,
  ssh_support: true,
  web_support: false,
},
{
  id: 34,
  title: "Nvidia Cumulus",
  description: t("resources.switch"),
  logoComponent: <SiNvidia />,
  color: "#76B900",
  resource_type: "switch",
  isNetworkingDevice: true,
  ssh_support: true,
  web_support: false,
},
{
  id: 35,
  title: "Arista",
  description: t("resources.switch"),
  imageURL: images.arista,
  resource_type: "switch",
  isNetworkingDevice: true,
  ssh_support: true,
  web_support: false,
},
{
  id: 36,
  title: "Huawei",
  description: t("resources.switch"),
  logoComponent: <SiHuawei />,
  color: "#CE0E2D",
  resource_type: "switch",
  isNetworkingDevice: true,
  ssh_support: true,
  web_support: true,
},
{
  id: 37,
  title: "EdgeCore",
  description: t("resources.switch"),
  imageURL: images.edgecore,
  resource_type: "switch",
  isNetworkingDevice: true,
  ssh_support: true,
  web_support: true,
},
{
  id: 38,
  title: "Custom Switch",
  description: t("resources.switch"),
  imageURL: images.customWebApp,
  resource_type: "switch",
  isNetworkingDevice: true,
  ssh_support: true,
  web_support: true,
},
// Networking Devices - Routers
{
  id: 39,
  title: "Juniper Networks",
  description: t("resources.router"),
  logoComponent: <SiJunipernetworks />,
  color: "#000000",
  resource_type: "router",
  isNetworkingDevice: true,
  ssh_support: true,
  web_support: true,
},
{
  id: 40,
  title: "MikroTik",
  description: t("resources.router"),
  logoComponent: <SiMikrotik />,
  color: "#323232",
  resource_type: "router",
  isNetworkingDevice: true,
  ssh_support: true,
  web_support: true,
},
{
  id: 41,
  title: "Nokia Devices",
  description: t("resources.router"),
  logoComponent: <SiNokia />,
  color: "#005AFF",
  resource_type: "router",
  isNetworkingDevice: true,
  ssh_support: true,
  web_support: false,
},
{
  id: 42,
  title: "Fortinet",
  description: t("resources.router"),
  logoComponent: <SiFortinet />,
  color: "#DA291C",
  resource_type: "router",
  isNetworkingDevice: true,
  ssh_support: true,
  web_support: true,
},
{
  id: 43,
  title: "Huawei",
  description: t("resources.router"),
  logoComponent: <SiHuawei />,
  color: "#CE0E2D",
  resource_type: "router",
  isNetworkingDevice: true,
  ssh_support: true,
  web_support: true,
},
{
  id: 44,
  title: "EdgeCore",
  description: t("resources.router"),
  imageURL: images.edgecore,
  resource_type: "router",
  isNetworkingDevice: true,
  ssh_support: true,
  web_support: true,
},
{
  id: 45,
  title: "Custom Router",
  description: t("resources.router"),
  imageURL: images.customWebApp,
  resource_type: "router",
  isNetworkingDevice: true,
  ssh_support: true,
  web_support: true,
},
// Networking Devices - Firewalls
{
  id: 46,
  title: "Check Point",
  description: t("resources.firewall"),
  imageURL: images.checkpoint,
  resource_type: "firewall",
  isNetworkingDevice: true,
  ssh_support: true,
  web_support: true,
},
{
  id: 47,
  title: "Cisco ASA",
  description: t("resources.firewall"),
  imageURL: images.cisco_asa,
  resource_type: "firewall",
  isNetworkingDevice: true,
  ssh_support: true,
  web_support: true,
},
{
  id: 48,
  title: "Fortinet",
  description: t("resources.firewall"),
  logoComponent: <SiFortinet />,
  color: "#DA291C",
  resource_type: "firewall",
  isNetworkingDevice: true,
  ssh_support: true,
  web_support: true,
},
{
  id: 49,
  title: "Juniper Networks",
  description: t("resources.firewall"),
  logoComponent: <SiJunipernetworks />,
  color: "#000000",
  resource_type: "firewall",
  isNetworkingDevice: true,
  ssh_support: true,
  web_support: true,
},
{
  id: 50,
  title: "Palo Alto",
  description: t("resources.firewall"),
  imageURL: images.palo_alto,
  resource_type: "firewall",
  isNetworkingDevice: true,
  ssh_support: true,
  web_support: true,
},
{
  id: 51,
  title: "Barracuda",
  description: t("resources.firewall"),
  imageURL: images.barracuda,
  resource_type: "firewall",
  isNetworkingDevice: true,
  ssh_support: true,
  web_support: true,
},
{
  id: 52,
  title: "Huawei",
  description: t("resources.firewall"),
  logoComponent: <SiHuawei />,
  color: "#CE0E2D",
  resource_type: "firewall",
  isNetworkingDevice: true,
  ssh_support: true,
  web_support: true,
},
{
  id: 53,
  title: "SonicWall",
  description: t("resources.firewall"),
  imageURL: images.sonicwall,
  resource_type: "firewall",
  isNetworkingDevice: true,
  ssh_support: true,
  web_support: true,
},
{
  id: 54,
  title: "Sophos",
  description: t("resources.firewall"),
  imageURL: images.sophos,
  resource_type: "firewall",
  isNetworkingDevice: true,
  ssh_support: true,
  web_support: true,
},
{
  id: 55,
  title: "WatchGuard",
  description: t("resources.firewall"),
  imageURL: images.watchguard,
  resource_type: "firewall",
  isNetworkingDevice: true,
  ssh_support: true,
  web_support: true,
},
{
  id: 56,
  title: "Array Networks",
  description: t("resources.firewall"),
  imageURL: images.array,
  resource_type: "firewall",
  isNetworkingDevice: true,
  ssh_support: true,
  web_support: true,
},
{
  id: 57,
  title: "Custom Firewall",
  description: t("resources.firewall"),
  imageURL: images.customWebApp,
  resource_type: "firewall",
  isNetworkingDevice: true,
  ssh_support: true,
  web_support: true,
},
  {
    id: 31,
    title: "PLC / Controller",
    description: "OT Device",
    imageURL: images.plc,
    resource_type: "ot_device",
    link: "/dashboard/resources/assets/add-assets/telnet?category=OT&ot_device_type=plc",
  },
  {
    id: 32,
    title: "HMI Panel",
    description: "OT Device",
    imageURL: images.hmi,
    resource_type: "ot_device",
    link: "/dashboard/resources/assets/add-assets/vnc?category=OT&ot_device_type=hmi",
  },
  {
    id: 33,
    title: "SCADA Server",
    description: "OT Device",
    imageURL: images.scada,
    resource_type: "ot_device",
    link: "/dashboard/resources/assets/add-assets/rdp?category=OT&ot_device_type=scada",
  },
  {
    id: 34,
    title: "Industrial Switch / Router",
    description: "OT Device",
    imageURL: images.industrial_switch,
    resource_type: "ot_device",
    link: "/dashboard/resources/assets/add-assets/telnet?category=OT&ot_device_type=industrial_switch",
  },
  {
    id: 35,
    title: "Engineering Station",
    description: "OT Device",
    imageURL: images.engineering_station,
    resource_type: "ot_device",
    link: "/dashboard/resources/assets/add-assets/rdp?category=OT&ot_device_type=engineering_station",
  },
  {
    id: 36,
    title: "IoT / OT Gateway",
    description: "OT Device",
    imageURL: images.telnet,
    resource_type: "ot_device",
    link: "/dashboard/resources/assets/add-assets/ssh?category=OT&ot_device_type=iot_gateway",
  },
  {
    id: 58,
    title: "FTP",
    beta: true,
    description: t("resources.server"),
    imageURL: images.ftp,
    resource_type: "server",
    link: "/dashboard/resources/assets/add-assets/ftp",
  },
  {
    id: 59,
    title: "MongoDB",
    beta: true,
    description: t("resources.database"),
    imageURL: images.MongoDb,
    resource_type: "database",
    link: "/dashboard/resources/apps/add-apps/mongodb",
  },
];

export const ReportCardsData = (t, capabilities = {}) => {
  const isChildCustomerContext = !!localStorage.getItem('managed_customer_id');
  const isCapable = "is_admin_user" in capabilities ? capabilities : false;
  const reports = [
    isCapable &&
      isCapable.report.apps_report && {
        id: 1,
        title: t("reports.databasesReport"),
        description: t("reports.detailedInformationAboutDatabasesReport"),
        imageComponent: (
          <FaDatabase color="#E04958" size={22} className="m-2" />
        ),
        color: "#FFFAE1",
        link: "/audit-dashboard/reports/databases-report",
      },
    isCapable &&
      isCapable.report.apps_access_report && {
        id: 2,
        title: t("reports.databasesAccessReport"),
        description: t("reports.detailedInformationAboutDatabasesAccessReport"),
        color: "#FFFAE1",
        imageComponent: (
          <FaDatabase color="#E04958" size={22} className="m-2" />
        ),
        link: "/audit-dashboard/reports/databases-access-report",
      },
    isCapable &&
      isCapable.report.apps_allocation_report && {
        id: 3,
        title: t("reports.databasesAllocationReport"),
        description: t("reports.detailedInformationAboutDatabasesAllocationReport"),
        color: "#FFFAE1",
        imageComponent: (
          <FaDatabase color="#E04958" size={22} className="m-2" />
        ),
        link: "/audit-dashboard/reports/databases-allocation-report",
      },
    isCapable &&
      isCapable.report.assets_report && {
        id: 4,
        title: t("reports.serversReport"),
        description: t("reports.detailedInformationAboutServersReport"),
        color: "#EBFCF6",
        imageComponent: <FaServer color="#30E1AB" size={23} />,
        link: "/audit-dashboard/reports/servers-report",
      },
    isCapable &&
      isCapable.report.assets_access_report && {
        id: 5,
        title: t("reports.serversAccessReport"),
        description: t("reports.detailedInformationAboutServersAccessReport"),
        color: "#EBFCF6",
        imageComponent: <FaServer color="#30E1AB" size={23} />,
        link: "/audit-dashboard/reports/servers-access-report",
      },
    isCapable &&
      isCapable.report.assets_allocation_report && {
        id: 6,
        title: t("reports.serversAllocationReport"),
        description: t("reports.detailedInformationAboutServersAllocationReport"),
        color: "#EBFCF6",
        imageComponent: <FaServer color="#30E1AB" size={23} />,
        link: "/audit-dashboard/reports/servers-allocation-report",
      },
    isCapable &&
      isCapable.report.ot_devices_report && {
        id: 40,
        title: t("reports.otDevicesReport"),
        description: t("reports.detailedInformationAboutOtDevicesReport"),
        color: "#FFF5E1",
        imageComponent: <FaIndustry color="#D97706" size={22} className="m-2" />,
        link: "/audit-dashboard/reports/ot-devices-report",
      },
    isCapable &&
      isCapable.report.ot_devices_access_report && {
        id: 41,
        title: t("reports.otDevicesAccessReport"),
        description: t("reports.detailedInformationAboutOtDevicesAccessReport"),
        color: "#FFF5E1",
        imageComponent: <FaIndustry color="#D97706" size={22} className="m-2" />,
        link: "/audit-dashboard/reports/ot-devices-access-report",
      },
    isCapable &&
      isCapable.report.ot_devices_allocation_report && {
        id: 42,
        title: t("reports.otDevicesAllocationReport"),
        description: t("reports.detailedInformationAboutOtDevicesAllocationReport"),
        color: "#FFF5E1",
        imageComponent: <FaIndustry color="#D97706" size={22} className="m-2" />,
        link: "/audit-dashboard/reports/ot-devices-allocation-report",
      },
    isCapable &&
      isCapable.report.web_apps_report && {
        id: 7,
        title: t("reports.webAppsReport"),
        description: t("reports.detailedInformationAboutWebAppsReport"),
        color: "#E7E9F8",
        imageComponent: <GiWorld color="#6367f9" size={25} />,
        link: "/audit-dashboard/reports/web-apps-report",
      },
    isCapable &&
      isCapable.report.web_apps_access_report && {
        id: 8,
        title: t("reports.webAppsAccessReport"),
        description: t("reports.detailedInformationAboutWebAppsAccessReport"),
        color: "#E7E9F8",
        imageComponent: <GiWorld color="#6367f9" size={25} />,
        link: "/audit-dashboard/reports/web-apps-access-report",
      },
    isCapable &&
      isCapable.report.webapps_allocation_report && {
        id: 9,
        title: t("reports.webAppsAllocationReport"),
        description: t("reports.detailedInformationAboutWebAppsAllocationReport"),
        color: "#E7E9F8",
        imageComponent: <GiWorld color="#6367f9" size={25} />,
        link: "/audit-dashboard/reports/web-apps-allocation-report",
      },
    isCapable &&
      isCapable.report.ticket_report && {
        id: 10,
        title: t("reports.ticketsReport"),
        description: t("reports.detailedInformationAboutTicketsReport"),
        color: "#FFE8E8",
        imageComponent: <LuTicketCheck size={23} />,
        link: "/audit-dashboard/reports/tickets-report",
      },
    isCapable.report?.users_report && {
      id: 11,
      title: t("reports.usersReport"),
      description: t("reports.detailedInformationAboutUsersReport"),
      color: "#FEF1EB",
      imageComponent: <FaUserAlt color="#F56A3F" size={19} />,
      link: "/audit-dashboard/reports/users-report",
    },
    isCapable &&
      isCapable.report.user_login_report && {
        id: 12,
        title: t("reports.usersLoginReport"),
        description: t("reports.detailedInformationAboutUsersLoginReport"),
        color: "#FEF1EB",
        imageComponent: <FaUserAlt color="#F56A3F" size={19} />,
        link: "/audit-dashboard/reports/users-login-report",
      },
    isCapable &&
      isCapable.report.roles_report && {
        id: 13,
        title: t("reports.rolesReport"),
        description: t("reports.detailedInformationAboutRolesReport"),
        color: "#FEF1EB",
        imageComponent: <FaUserAlt color="#F56A3F" size={19} />,
        link: "/audit-dashboard/reports/roles-report",
      },
    isCapable &&
      isCapable.report.groups_report && {
        id: 14,
        title: t("reports.groupsReport"),
        description: t("reports.detailedInformationAboutGroupsReport"),
        color: "#FEF1EB",
        imageComponent: <MdGroups color="#F56A3F" size={25} />,
        link: "/audit-dashboard/reports/groups-report",
      },
    isCapable.report?.systemuser_report && {
      id: 15,
      title: t("reports.systemUsersReport"),
      description: t("reports.detailedInformationAboutSystemUsersReport"),
      color: "#E7E9F8",
      imageComponent: <FaUserShield color="#6367F9" size={23} />,
      link: "/audit-dashboard/reports/system-users-report",
    },
    isCapable &&
      isCapable.report.system_user_password_rotation_report && {
        id: 16,
        title: t("reports.systemUsersPasswordRotationReport"),
        description: t("reports.detailedInformationAboutSystemUsersPasswordRotationReport"),
        color: "#E7E9F8",
        imageComponent: <FaUserShield color="#6367F9" size={23} />,
        link: "/audit-dashboard/reports/system-users-password-rotation-policy-report",
      },
      isCapable  && isCapable.report.certificate_report && {
        id: 20,
        title: t("reports.certificateReport"),
        description: t("reports.detailedInformationAboutCertificateReport"),
        color: "#E7E9F8",
        imageComponent: <TbCertificate size={23} color="#6367F9" />,
        link: "/audit-dashboard/reports/certificate-report",
      },
    isCapable &&
      isCapable.report.password_rotation_policy_report && {
        id: 17,
        title: t("reports.passwordsRotationPolicyReport"),
        description: t("reports.detailedInformationAboutPasswordsRotationPolicyReport"),
        color: "#e2ffe1",
        imageComponent: <RiLockPasswordLine size={23} />,
        link: "/audit-dashboard/reports/passwords-rotation-policy-report",
      },
    isCapable &&
      isCapable.report.client_credential_report && {
        id: 18,
        title: t("reports.clientCredentialsReport"),
        description: t("reports.detailedInformationAboutClientCredentialsReport"),
        color: "#e2ffe1",
        imageComponent: <RiLockPasswordLine size={23} />,
        link: "/audit-dashboard/reports/client-credentials-report",
      },
    isCapable &&
      isCapable.report.client_credential_report && {
        id: 19,
        title: t("reports.clientCredentialsUsageReport"),
        description: t("reports.detailedInformationAboutClientCredentialsUsageReport"),
        color: "#e2ffe1",
        imageComponent: <RiLockPasswordLine size={23} />,
        link: "/audit-dashboard/reports/client-credentials-usage-report",
      },
    isCapable &&
      isCapable.report?.cloud_discovery_report && {
        id: 21,
        title: t("reports.cloudDiscoveryConfigReport"),
        description: t("reports.cloudDiscoveryConfigReportDesc"),
        color: "#E7F3FF",
        imageComponent: <RiCloudLine color="#5177FF" size={23} />,
        link: "/audit-dashboard/reports/cloud-discovery-config-report",
      },
    isCapable &&
      isCapable.report?.cloud_discovery_report && {
        id: 22,
        title: t("reports.cloudDiscoveryScanReport"),
        description: t("reports.cloudDiscoveryScanReportDesc"),
        color: "#E7F3FF",
        imageComponent: <RiCloudLine color="#5177FF" size={23} />,
        link: "/audit-dashboard/reports/cloud-discovery-scan-report",
      },
    isCapable &&
      isCapable.report?.cloud_discovery_report && {
        id: 23,
        title: t("reports.cloudDiscoveryOnboardReport"),
        description: t("reports.cloudDiscoveryOnboardReportDesc"),
        color: "#E7F3FF",
        imageComponent: <RiCloudLine color="#5177FF" size={23} />,
        link: "/audit-dashboard/reports/cloud-discovery-onboard-report",
      },
    isCapable && isCapable.report.credentials_checkout_report && {
        id: 20,
        title: t("reports.credentialActionReport"),
        description: t("reports.detailedInformationAboutCredentialActionReport"),
        imageComponent: (
          <RiLockPasswordLine color="#E04958" size={22} className="m-2" />
        ),
        color: "#FFFAE1",
        link: "/audit-dashboard/reports/credential-action-report",
      },
      isCapable && isCapable.report.application_credentials_access_report && {
        id: 21,
        title: t("reports.applicationCredentialsAccessReport"),
        description: t("reports.applicationCredentialsAccessReportDesc"),
        imageComponent: (
          <RiLockPasswordLine color="#E04958" size={22} className="m-2" />
        ),
        color: "#FFFAE1",
        link: "/audit-dashboard/reports/application-credentials-access-report",
      },
      isCapable && isCapable.report.application_credentials_allocation_report && {
        id: 22,
        title: t("reports.applicationCredentialsAllocationReport"),
        description: t("reports.applicationCredentialsAllocationReportDesc"),
        imageComponent: (
          <RiLockPasswordLine color="#E04958" size={22} className="m-2" />
        ),
        color: "#FFFAE1",
        link: "/audit-dashboard/reports/application-credentials-allocation-report",
      },
      isCapable && isCapable.report?.customer_management_report && !isChildCustomerContext && {
        id: 25,
        title: t("customers.report.title"),
        description: t("customers.report.description"),
        color: "#E7E9F8",
        imageComponent: <FaUserShield color="#6367F9" size={23} />,
        link: "/audit-dashboard/reports/customer-management-report",
      },
    isCapable && isCapable.report.web_app_policy_report && {
      id: 23,
      title: t ? t("reports.webAppPolicyReport") : "Web App Policy Report",
      description: t ? t("reports.detailedInformationAboutWebAppPolicyReport") : "Audit trail for Web App policy create, edit and delete actions",
      color: "#E7E9F8",
      imageComponent: <GiWorld color="#6367f9" size={25} />,
      link: "/audit-dashboard/reports/web-app-policy-report",
    },
    isCapable && isCapable.report.rdp_vnc_policy_report && {
      id: 24,
      title: t ? t("reports.rdpVncPolicyReport") : "RDP/VNC Policy Report",
      description: t ? t("reports.detailedInformationAboutRdpVncPolicyReport") : "Audit trail for RDP/VNC policy create, edit and delete actions",
      color: "#EBFCF6",
      imageComponent: <FaServer color="#30E1AB" size={23} />,
      link: "/audit-dashboard/reports/rdp-vnc-policy-report",
    },
    isCapable && isCapable.report.ssh_sftp_smb_policy_report && {
      id: 25,
      title: t ? t("reports.sshSftpSmbPolicyReport") : "SSH/SFTP/SMB Policy Report",
      description: t ? t("reports.detailedInformationAboutSshSftpSmbPolicyReport") : "Audit trail for SSH/SFTP/SMB policy create, edit and delete actions",
      color: "#EBFCF6",
      imageComponent: <FaServer color="#30E1AB" size={23} />,
      link: "/audit-dashboard/reports/ssh-sftp-smb-policy-report",
    },
    isCapable && isCapable.report.database_policy_report && {
      id: 26,
      title: t ? t("reports.databasePolicyReport") : "Database Policy Report",
      description: t ? t("reports.detailedInformationAboutDatabasePolicyReport") : "Audit trail for Database policy create, edit and delete actions",
      color: "#FFFAE1",
      imageComponent: <FaDatabase color="#E04958" size={22} className="m-2" />,
      link: "/audit-dashboard/reports/database-policy-report",
    },
    isCapable && isCapable.report.vault_password_policy_report && {
      id: 27,
      title: t ? t("reports.passwordPolicyReport") : "Password Policy Report",
      description: t ? t("reports.detailedInformationAboutPasswordPolicyReport") : "Audit trail for Vault Password policy create, edit and delete actions",
      color: "#e2ffe1",
      imageComponent: <RiLockPasswordLine size={23} />,
      link: "/audit-dashboard/reports/vault-password-policy-report",
    },
  ].filter(Boolean);
  return reports;
};

export const CloudConfigurationData = (t) => {
  const cards = [
    {
      id: 1,
      beta: true,
      title: t("cloudDiscovery.amazonWebServices"),
      description: t("cloudDiscovery.awsDescription"),
      imageURL: AWSLogo,
      link:
        "/dashboard/discovery/cloudconfiguration/add-cloudconfiguration?provider=aws",

    },
    {
      id: 2,
      title: t("cloudDiscovery.googleCloudProvider"),
      commingsoon: true,
      description: t("cloudDiscovery.gcpDescription"),
      imageURL: GoogleCloudLogo,
      link:
        "/dashboard/discovery/cloudconfiguration/select-plateform/add-configuration",
    },
    {
      id: 3,
      title: t("cloudDiscovery.azure"),
      commingsoon: true,
      description: t("cloudDiscovery.azureDescription"),
      imageURL: AzureLogo,
      link:
        "/dashboard/discovery/cloudconfiguration/select-plateform/add-configuration",
    },

  ];
  return cards;
};